import { RefObject, useEffect } from 'react';
import { useChatBlkContext } from '../providers';
import { QueryState } from '../types';
import useChatBlkStore from './useChatBlkStore';

const useBubbleAnimations = (
    state: QueryState,
    hashId: string,
    chatExchangeRef: RefObject<HTMLDivElement>
) => {
    const {
        setPaddingHeight,
        mostRecentQueryId,
        activeQueryId: isGeneratingResponse,
    } = useChatBlkStore();
    const { chatCanvasRef } = useChatBlkContext();
    const isLast = mostRecentQueryId === hashId;

    useEffect(() => {
        if (chatExchangeRef?.current) {
            const scrollCanvasEl =
                chatCanvasRef.current.shadowRoot.querySelector(
                    '.bxf-chat-canvas__chat-container--scroll'
                );
            setTimeout(() => {
                // Height of the window between the chat header and footer
                const chatHeight = scrollCanvasEl?.clientHeight || 0;
                // Height of the chat bubble response element and query from user
                const chatExchangeHeight =
                    chatExchangeRef.current?.clientHeight || 0;
                // Set the padding height expected once the chat bubble response is rendered
                const loadedHeight = Math.max(
                    chatHeight - chatExchangeHeight,
                    0
                );
                setPaddingHeight(
                    state === QueryState.LOADED ? loadedHeight : chatHeight
                );
            }, 200);

            const { scrollX, scrollY } = window;
            setTimeout(() => {
                chatExchangeRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: isLast ? 'start' : 'end',
                });
                window.scrollTo(scrollX, scrollY); // restore scroll position
            }, 200);
        }
    }, [state, chatExchangeRef, isGeneratingResponse]);
    return {
        chatExchangeRef,
        isLast,
        prompt,
    };
};
export default useBubbleAnimations;
